import { LoadMethod, LoadResp } from 'src/database/types.ts';
import LoadWorker from 'src/database/load.worker?worker&inline';

export const checkDatabaseViaWorker = (url: string) => {
    const worker = new LoadWorker();
    return new Promise((resolve, reject) => {
        const channel = new MessageChannel();
        channel.port2.onmessage = (event: MessageEvent<LoadResp>) => {
            channel.port2.close();
            if ('error' in event.data) {
                reject(event.data.error);
                worker.terminate();
            } else {
                resolve(event.data.response);
                worker.terminate();
            }
        };
        worker.postMessage({ method: 'load', params: [url] } satisfies LoadMethod, [channel.port1]);
    });
};
